import { ContentCopy as CopyIcon } from "@mui/icons-material";
import { Snackbar } from "@mui/material";
import Button from "components/common/Button";
import IconButton from "components/common/IconButton";
import { useState } from "react";

const CopyButton = ({ content, tooltip, scale, variant, label }) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("Copied to clipboard");

  const isButtonVariant = (variant ?? "").trim().toLowerCase() === "button";

  const handleCopy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(content);
      setSnackbarMessage("Copied to clipboard");
      setSnackbarOpen(true);
    } catch {
      // Fallback for older browsers or when clipboard API fails
      const textArea = document.createElement("textarea");
      textArea.value = content;
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        setSnackbarMessage("Copied to clipboard");
        setSnackbarOpen(true);
      } catch {
        setSnackbarMessage("Failed to copy");
        setSnackbarOpen(true);
      } finally {
        document.body.removeChild(textArea);
      }
    }
  };

  return (
    <>
      {isButtonVariant ? (
        <Button onClick={handleCopy} size={scale}>
          {label}
        </Button>
      ) : (
        <IconButton
          icon={CopyIcon}
          scale={scale}
          onClick={handleCopy}
          tooltip={tooltip}
        />
      )}
      <Snackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={1250}
        ContentProps={{
          sx: { justifyContent: "center", borderRadius: "1.5rem" },
        }}
      />
    </>
  );
};

export default CopyButton;
